import { useState } from 'react';
import { Link } from 'react-router-dom';
import { useDeleteItem, useItems, useMe } from '../api/hooks';
import { DraftBanner } from '../components/DraftBanner';

export function ItemsPage() {
  const items = useItems();
  const del = useDeleteItem();
  const me = useMe();
  const isApprover = me.data?.user?.role === 'approver';
  const [err, setErr] = useState<string | null>(null);

  return (
    <>
      <div className="page-head">
        <h1>Items</h1>
        <Link className="btn primary" to="/items/new">
          Add Item / Service
        </Link>
      </div>
      <DraftBanner kind="item" to="/items/new" label="item" />
      <div className="card">
        {err && <div className="banner error">{err}</div>}
        {items.isLoading && <p className="muted">Loading…</p>}
        {items.data && items.data.length === 0 && <p className="muted">No items created in the app yet.</p>}
        {items.data && items.data.length > 0 && (
          <div className="table-wrap">
            <table>
              <thead>
                <tr>
                  <th>Name</th>
                  <th>QuickBooks Id</th>
                  <th>Status</th>
                  {isApprover && <th></th>}
                </tr>
              </thead>
              <tbody>
                {items.data.map((it) => (
                  <tr key={it.id}>
                    <td>{it.displayName ?? it.localRef}</td>
                    <td>{it.qboId ?? '—'}</td>
                    <td>{it.status}</td>
                    {isApprover && (
                      <td className="right">
                        <button
                          onClick={() => {
                            setErr(null);
                            if (window.confirm('Delete this item? It is made inactive in QuickBooks — only if it is not used on any quote.')) {
                              del.mutate(it.id, { onError: (e) => setErr((e as Error).message) });
                            }
                          }}
                          disabled={del.isPending}
                        >
                          Delete
                        </button>
                      </td>
                    )}
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
        <p className="muted" style={{ fontSize: '0.8rem', marginTop: '0.75rem' }}>
          These are items created through this app. Delete makes an item inactive in QuickBooks — blocked if it is used on any quote.
        </p>
      </div>
    </>
  );
}
